import { BalloonForVLP } from "./BalloonForVLP";

export class BalloonApp {
    constructor(pmdrs, config) {
        let app = this;
        app.pmdrs = pmdrs;
        // config
        this.config = app.defaultConfig();
        Object.assign(this.config, config);
    }

    init() {
        this.vlpInfo = new BalloonForVLP(this);
    }

    defaultConfig() {
        return {
            elementId: "",
            vehicle: {
                finalPrice: "35525", //listedPrice
                retailPrice: "42525", //MSRP
                condition: "new", //new, used
                vin: "1C4HJXDGXMW840919", //,'2C3CCARG3MH649453',//'3N1CN8BV8LL870448',
                stockNumber: "345687",
                mileage: "1",
                year: "2021",
                make: "JEEP",
                model: "Wrangler",
                trim: "123456",
                vdpUrl: "#vdpUrl",
                imgUrl: "https://es.ramtrucks.com/content/dam/fca-brands/na/ramtrucks/en_us/bhp/lineup/RAM-BHP-LINEUP-TRX-Two-Tone.jpg.image.500.jpg",
            },
            apr: {
                finance: null,
                lease: null,
            },
        };
    }
}
